<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item active">Reasignación de Grupos</li>
</ol>

<h1 class="page-header"><i class="fas fa-exchange-alt"></i> Administración <small> Reasignación de Grupos</small></h1>

<panel [noButton]="true">
    <div class="row">
        <div class="col-md-12">
            <form [formGroup]="form">
                <div class="row mb-3">
                    <div class="col-md-4">
                        <label class="form-label">Póliza</label>
                        <ng-select [items]="policies" formControlName="policyId"
                            bindLabel="code" bindValue="_id" [clearable]="true" appendTo="body"
                            dropdownPosition="auto" placeholder="Seleccionar póliza"
                            (change)="onPolicyChange()">
                            <ng-template ng-label-tmp let-item="item">
                                {{ item.code }} - {{ item.coverage?.name }}
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                {{ item.code }} - {{ item.coverage?.name }} ({{ item.entity?.name }})
                            </ng-template>
                        </ng-select>
                    </div>

                    <div class="col-md-4">
                        <label class="form-label">Grupo Origen</label>
                        <ng-select [items]="originGroups" formControlName="originGroupId"
                            bindLabel="name" bindValue="_id" [clearable]="true" appendTo="body"
                            dropdownPosition="auto" placeholder="Seleccionar grupo origen"
                            (change)="onOriginGroupChange()">
                        </ng-select>
                    </div>

                    <div class="col-md-4">
                        <label class="form-label">Grupo Destino</label>
                        <ng-select [items]="destinationGroups" formControlName="destinationGroupId"
                            bindLabel="name" bindValue="_id" [clearable]="true" appendTo="body"
                            dropdownPosition="auto" placeholder="Seleccionar grupo destino">
                        </ng-select>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-4">
                        <label class="form-label">Desde Período</label>
                        <input type="month" class="form-control" formControlName="periodFrom"
                            (change)="onPeriodChange()"
                            title="A partir de este período se actualizará el grupo en todos los meses posteriores" />
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-6 text-center">
                        <button class="btn btn-primary btn-lg w-100" [disabled]="form.invalid" (click)="executeCharges()">
                            <i class="fas fa-play"></i> Ejecutar Reasignación Cobranzas
                        </button>
                    </div>
                    <div class="col-md-6 text-center">
                        <button class="btn btn-success btn-lg w-100" [disabled]="form.invalid" (click)="executeRequests()">
                            <i class="fas fa-exchange-alt"></i> Ejecutar Reasignación Movimientos
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>

    @if (previewLoaded) {
    <div class="row mt-4">
        <div class="col-md-12">
            <h5>Asegurados a migrar (Cobranzas) <span class="badge bg-primary">{{ preview.length }}</span></h5>
            <div class="table-responsive">
                <table class="table table-sm table-striped table-hover">
                    <thead>
                        <tr>
                            <th class="text-center">N°</th>
                            <th>Nombre Completo</th>
                            <th class="text-center">RUT</th>
                            <th class="text-center">DV</th>
                            <th>Tipo Aseg</th>
                            <th class="text-end">Capital</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for(item of preview; track item._id; let i = $index){
                        <tr>
                            <td class="text-center">{{ i + 1 }}</td>
                            <td>{{ item.nombreCompleto }}</td>
                            <td class="text-center">{{ item.rut }}</td>
                            <td class="text-center">{{ item.dv }}</td>
                            <td>{{ item.tipoAseg }}</td>
                            <td class="text-end">{{ item.capital }}</td>
                        </tr>
                        }
                        @empty {
                        <tr>
                            <td colspan="6" class="text-center">No hay asegurados para migrar</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    }

    @if (previewRequestsLoaded) {
    <div class="row mt-4">
        <div class="col-md-12">
            <h5>Movimientos a migrar <span class="badge bg-success">{{ previewRequests.length }}</span></h5>
            <div class="table-responsive">
                <table class="table table-sm table-striped table-hover">
                    <thead>
                        <tr>
                            <th class="text-center">N°</th>
                            <th>Nombre Completo</th>
                            <th class="text-center">RUT</th>
                            <th class="text-center">DV</th>
                            <th>Tipo Aseg</th>
                            <th class="text-center">Fecha Solicitud</th>
                            <th class="text-end">Capital</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for(item of previewRequests; track item._id; let i = $index){
                        <tr>
                            <td class="text-center">{{ i + 1 }}</td>
                            <td>{{ item.nombreCompleto }}</td>
                            <td class="text-center">{{ item.rut }}</td>
                            <td class="text-center">{{ item.dv }}</td>
                            <td>{{ item.tipoAseg }}</td>
                            <td class="text-center">{{ item.dateRequest | date:'dd-MM-yyyy' }}</td>
                            <td class="text-end">{{ item.capital }}</td>
                        </tr>
                        }
                        @empty {
                        <tr>
                            <td colspan="7" class="text-center">No hay movimientos para migrar</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    }

    @if (resultCharges) {
    <div class="row mt-4">
        <div class="col-md-12">
            <div class="alert alert-success">
                <strong>Resultado Cobranzas:</strong>
                Póliza {{ resultCharges.policyCode }} —
                <strong>{{ resultCharges.affectedRows }}</strong> registro(s) actualizado(s)
                de <em>{{ resultCharges.originGroupName }}</em> a <em>{{ resultCharges.destinationGroupName }}</em>
            </div>
        </div>
    </div>
    }

    @if (resultRequests) {
    <div class="row mt-4">
        <div class="col-md-12">
            <div class="alert alert-info">
                <strong>Resultado Movimientos:</strong>
                <strong>{{ resultRequests.requestsUpdated }}</strong> movimiento(s) actualizado(s)
                de <em>{{ resultRequests.originGroupName }}</em> a <em>{{ resultRequests.destinationGroupName }}</em>
            </div>
        </div>
    </div>
    }
</panel>
